/**
 * Download primitives for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
 */

'use strict';

import {
    checkNewFiles,
    disableWarningOnPageUnload,
    enableWarningOnPageUnload, escapeHtml,
    fileIsExpiredPrompt,
    freeTier,
    getItem,
    messagePrompt, mfetch,
    passwordPrompt,
    pinPrompt,
    showDownloadFailedPrompt,
    showDuplicateFileAlert,
    showFlash,
    showFreeTierDepletedPrompt,
    showPasswordErrorPrompt,
    showPinErrorPrompt, showTooltip,
    unverifiedDownloadPrompt,
    updateFileCounters
} from "./utils";
import {
    convertStringToArrayBufferView, decryptSymmetricKey,
    encryptMessage,
    extractSecretUsingLocalSecretKey,
    getSecretKey,
    getSymmetricAlgorithm,
    updateProgressStatus
} from "./crypto";
import {FileData} from "./upload";
// @ts-ignore
import {ZIP} from "./zip-stream.js";



// // @ts-ignore
// import bootstrap from "bootstrap";




import "web-streams-polyfill/es6";
// @ts-ignore
import streamSaver from 'streamsaver'
// @ts-ignore
import * as bootstrap from 'bootstrap';
streamSaver.mitm ='/mitm.html?version=2.0.0'
// streamSaver.WritableStream = streamSaver.WritableStream
// streamSaver.TransformStream = streamSaver.TransformStream
// if you decide to host mitm + sw yourself


export const updateTable = () => {
    const event1 = new CustomEvent('arc:update-table');
    window.dispatchEvent(event1);
    //v2
    const explorer = document.getElementById('transfer-file-list');
    if(explorer) {
        const event2 = new Event('arcano-explorer:update');
        explorer.dispatchEvent(event2);
    }
}

/**
 * Zips several files for multiple files download
 */
export function zipit(data: Array<FileData>, privateKey?: CryptoKey) {

    const date = new Date();
    const month: number = date.getMonth() + 1;

    let zipName: string = `ARCANO-${date.getFullYear()}-${month}-${date.getDate()}.zip`;

    const transferName = document.getElementById(data[0].prefix);
    if(transferName) {
        let name = transferName.innerText.trim()
        if(name !== 'Transfer') {
            zipName = `ARCANO-${name}.zip`;
        }
    }
    if(data[0].transfer_name) { //compat v2
        if(data[0].transfer_name !== 'Transfer') {
            zipName = `ARCANO-${data[0].transfer_name}.zip`;
        }
    }


    let fileSize: number = data.map(x => parseInt(x.real_size.toString())).reduce((a, b) => a + b, 0)

    let isUnverified: boolean = data.some(x => x.verified === "false");

    if (isUnverified) {
        const callback = (result: boolean) => {
            if (result) {
                zip()
            }
        };

        if (freeTier()) {
            unverifiedDownloadPrompt(callback)
        } else {
            showFreeTierDepletedPrompt()
        }

    } else {
        if (freeTier()) {
            zip()
        } else {
            showFreeTierDepletedPrompt()
        }
    }


    function zip() {
        // if (fileSize > 4 * 1000 * 1000 * 1000) {
        //     showZipTooLargePrompt()
        //     return
        // }

        const fileStream = streamSaver.createWriteStream(zipName, {size: fileSize})

        const files = data.values()
        const fileIds = data.map(x => x.prefix + '-' + x.name)

        if (data.length > 0 && data[0].password_hash !== 'None') {
            pinPrompt((passPhrase) => {
                if (passPhrase !== null) {

                    if (data.length > 0) {
                        let row = data[0]

                        getURLs([row.prefix, row.name].join('-'), passPhrase).then(() => {
                            execute(passPhrase).then(() => {
                            })
                        }).catch((e) => {
                            if (e.message === 'Wrong PIN') {
                                showPinErrorPrompt()
                            }
                        })
                    }
                }
            })
        } else {
            let passPhrase = "";
            execute(passPhrase).then(() => {
            })
        }

        // Getting a iterator `.values()` is good for task where you
        async function execute(passPhrase: any) {
            enableWarningOnPageUnload()
            // @ts-ignore
            const z = new ZIP({
                async pull(ctrl: any) {

                    const it = files.next()

                    if (it.done) {
                        ctrl.close()
                    } else {
                        const row = it.value

                        const urlData = await getURLs([row.prefix, row.name].join('-'), passPhrase)
                        // const d = await getURLs([row.prefix, row.name].join('-'), passPhrase);  // todo
                        let secret;
                        if (privateKey && document.location && document.location.pathname.indexOf('/external_download') < 0) {
                            secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, privateKey)
                        } else {
                            secret = document.location.hash
                        }

                        let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link

                        const split = hash.split('-');

                        if (split.length !== 2) {
                            return;  // invalid, todo: raise an alarm?
                        }


                        const counter = new Uint8Array(atob(split[0]).split(",").map(x => parseInt(x)));

                        const keydata = JSON.parse(atob(split[1]));

                        const algorithm = getSymmetricAlgorithm(counter);

                        const symmetricKey = await window.crypto.subtle.importKey('jwk',
                            keydata,
                            algorithm,
                            false,
                            keydata.key_ops
                        )

                        let encryptedFilename = row.encrypted_filepath
                        if(!encryptedFilename || encryptedFilename === 'null') {
                            encryptedFilename = row.encrypted_filename
                        }
                        const sencryptedFilename = atob(encryptedFilename);

                        let arraybuffer = convertStringToArrayBufferView(sencryptedFilename);

                        const decryptedFilename = await window.crypto.subtle.decrypt(
                            algorithm,
                            symmetricKey,
                            arraybuffer)
                        let realName = new TextDecoder("utf-8").decode(decryptedFilename);
                        if (realName.startsWith('/')) {  // no leading '/' in the zip, nobody likes that :)
                            realName = realName.slice(1)
                        }

                        const fileLike = {
                            name: realName,
                            stream() {
                                const stream = new ReadableStream({
                                    async pull(controller) {

                                        if (urlData.size === 0) {  // safari
                                            controller.enqueue(new Uint8Array());
                                            controller.close()
                                            return
                                        }

                                        // noinspection JSUnresolvedVariable
                                        const urls = urlData.urls;
                                        const ranges = urlData.ranges;
                                        const nChunks = urls.length
                                        while (urls.length > 0) {
                                            let url = urls.shift()!;
                                            let range = ranges.shift()!;
                                            let headers = {} as {range: string};
                                             if (range[0] !== null && range[1] !== null) {
                                                headers['range'] = `bytes=${range[0]}-${range[1] - 1}` // ok but for the last
                                            }

                                            const clearText = await fetch(url, {
                                                mode: "cors",
                                                headers: headers
                                            })
                                                .then(function (response) {
                                                    return response.arrayBuffer();
                                                })
                                                // .then(function (myBlob) {
                                                //     return new Response(myBlob).arrayBuffer()
                                                // })
                                                .then(function (buffer) {
                                                    return window.crypto.subtle.decrypt(
                                                        algorithm,
                                                        symmetricKey,
                                                        buffer
                                                    );
                                                })
                                            controller.enqueue(new Uint8Array(clearText)); // this conversion is important, arraybuffer is no valid format, we need uint8
                                            updateProgressStatus(`${row.prefix}-${row.name}`, urls, nChunks, urlData.size)
                                        }
                                        controller.close()
                                    }
                                })
                                return stream;
                            }
                        }
                        ctrl.enqueue(fileLike)
                    }
                }
            })
            z.pipeTo(fileStream)
                .then(() => {
                })
                .catch((e: any) => {
                    if (e.message.indexOf("File already exists") === 0) {
                        showDuplicateFileAlert(e.message.split(':')[1])
                    } else if (e.message.indexOf("null is not an object") === 0) {
                        showDuplicateFileAlert()
                    } else {
                        console.log('error ' + e)
                    }
                })
                .finally(() => { // acknowledge downloads
                    fetch("/download/done/", {
                        method: 'PUT',
                        body: JSON.stringify(fileIds),
                        // mode: 'cors',
                        headers: {
                            'Content-Type': 'application/json'
                            // 'Access-Control-Allow-Origin': '*'
                        },
                    }).then(() => {
                        updateTable()


                    })
                    disableWarningOnPageUnload()
                })
        }
    }
}

/**
 * Downlaods multiple files and stores them in a zip file, all in browser because we must decrypt files first
 */
export function downloadMultipleFiles(db: IDBDatabase, data: Array<FileData>) {


    const onerror = () => {

    }
    const oncomplete = async (event: any) => {
        let privateKey = event.target.result;
        zipit(data, privateKey)
    }

    if (db) {
        getItem(db, 'key', oncomplete, onerror)
    } else {
        const callback = async (password: string) => {
            if (password) {
                let key = await getSecretKey(password);
                if (key) {
                    zipit(data, key)
                } else {
                    showPasswordErrorPrompt()
                }
            }
        };
        if (document.location.hash === "") {
            passwordPrompt(callback)
        } else {
            zipit(data)
        }
    }
}
/**
 * Calls / download / uuid to get
 */
async function getURLs(fileId: string, passPhrase?: string): Promise<{ urls: Array<string>, size: number, ranges: Array<Array<number>> }> {
    // check if the file needs a passphrase
    const response_info = await mfetch('/download/info/' + fileId);

    if (response_info.status === 404) {
        fileIsExpiredPrompt()
        updateTable()
        return {size: 0, urls: [], ranges: []}
    }

    const response_info_json = await response_info.json();

    let response_list;

    if (response_info_json['passphrase_required']) {

        response_list = await mfetch('/download/list/' + fileId, {
            headers: {
                'Passphrase': encodeURIComponent(passPhrase as string)
            }
        }).then((response) => {
            if (response.status === 401) {
                // $wrongPin.show()
                throw new Error("Wrong PIN");
            }
            if (response.status >= 400 && response.status < 600) {
                throw new Error("Bad response from server");
            }
            return response;
        })
    } else {
        response_list = await fetch('/download/list/' + fileId);
    }
    let urls;
    let ranges;
    if (response_list && response_list.status === 200) {
        const data = await response_list.json();
        urls = data.urls;
        ranges = data.ranges;
    } else {
        urls = []
        ranges = []
    }
    return {size: response_info_json.size, urls, ranges: ranges}
}


/**
 * Download all chunks. Contains a closure that downloads one chunk at a time and then enqueues the next until the end
 */
async function download(urls: Array<string>,
                        ranges: Array<Array<number>>,
                        algorithm: Algorithm,
                        key: CryptoKey,
                        realName: string,
                        size: number,
                        fileId: string,
                        prefix: string,
                        name: string): Promise<void> {
    // showProgress();
    enableWarningOnPageUnload()


    const stream = streamSaver.createWriteStream(realName, {size: size});  // { size: max * byte.length }, size: blob.size /

    const nChunks = urls.length;

    updateProgressStatus(`${prefix}-${name}`, urls, nChunks, size);

    let writer = stream.getWriter();
    // writer.write(new Uint8Array(''))

    const erroneousUrls = [];

    while (urls.length > 0) {

        let url = urls.shift()!;
        let range = ranges.shift()!;
        let headers = {'Cache-Control': 'no-store, max-age=0'}
        if (range[0] !== null && range[1] !== null) {
            // @ts-ignore
            headers['range'] = `bytes=${range[0]}-${range[1] - 1}` // ok but for the last
        }

        await fetch(url as RequestInfo, {
            mode: "cors",
            headers: headers

            // headers: {'Access-Control-Allow-Origin': '*'}
        })
            .then(function (response) {
                return response.arrayBuffer()
            })
            .then(function (buffer) {
                return window.crypto.subtle.decrypt(
                    algorithm,
                    key,
                    buffer
                );
            })
            .then(function (clearText) {
                writer.write(new Uint8Array(clearText));
                updateProgressStatus(`${prefix}-${name}`, urls, nChunks, size);
            })
            .catch(function (err) {
                if(err.name === "OperationError") {  // safari 0-byte decryption error
                    writer.write(new Uint8Array());
                    updateProgressStatus(`${prefix}-${name}`, urls, nChunks, size);
                } else {
                    erroneousUrls.push({error: err, url: url});
                }
            });
    }

    try {
        if (erroneousUrls.length > 0) {
           await writer.abort(); // todo replace with a nice UI
            window.alert('Download failed');
        } else {

            await fetch("/download/done/" + fileId, {
                method: 'PUT',
                // mode: 'cors',
                headers: {
                    'Content-Type': 'text/plain',
                },
            })
        }

    } catch(e) {
        console.log(e)
        showDownloadFailedPrompt()
    } finally {
        disableWarningOnPageUnload()
        await writer.close();
    }

    // elem.parentElement.parentElement.style.color = 'unset'

    updateTable()

}

/**
 * Starts the downloads
 */
async function launchDownloads(hash: string, row: FileData, passPhrase?: string): Promise<void> {

    const prefix = row.prefix
    const name = row.name
    const encryptedFilename = row.encrypted_filename


    const {algorithm, key} = await decryptSymmetricKey(hash)

    window.location.pathname.replace('/', '');

    const sencryptedFilename = atob(encryptedFilename);

    let arraybuffer = convertStringToArrayBufferView(sencryptedFilename);

    const decryptedFilename = await window.crypto.subtle.decrypt(
        algorithm,
        key,
        arraybuffer
    );
    const realName = new TextDecoder("utf-8").decode(decryptedFilename);
    let d;
    const fileId = [prefix, name].join('-');
    try {
        d = await getURLs(fileId, passPhrase);
    } catch (e) {
        showPinErrorPrompt();
        return
    }
    if (!d) {
        return
    }
    const urls = d.urls;
    const size = d.size;
    const ranges = d.ranges;
    if (urls.length > 0) {
        await download(urls, ranges, algorithm, key, realName, size, fileId, prefix, name);
    } else {
        showFlash('No files to download', 'danger')
    }
}


/**
 * get the download link for outloook plugin
 */
export async function mainFileLinkPlugin(db: IDBDatabase, row: FileData) {
    if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key

        const onerror = () => {
            console.log('?')
        }

        const oncomplete = async (event: any) => {
            let key = event.target.result;
            extractSecretUsingLocalSecretKey(row.encryptedkey, key).then((secret) => {
                if (secret.includes('?prefix=')) {
                    // inject the 'name' as a query_string arg into the secret
                    const prefixIndex = secret.indexOf('?prefix=');
                    const nameQS = "name=" + row.name + "&";
                    secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
                    console.log('post message')
                    window.parent.postMessage(secret, '*')
                }
            })
        }
        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        }
        // else {
        //
        //
        //     async function callback(modalPassword) {
        //         let key = await getSecretKey(modalPassword);
        //         if (key) {
        //             let secret = await extractSecretUsingLocalSecretKey(prefix, name, key)
        //             if (forceSingleFile && secret.includes('?prefix=')) {
        //                 // inject the 'name' as a query_string arg into the secret
        //                 const prefixIndex = secret.indexOf('?prefix=');
        //                 const nameQS = "name=" + name + "&";
        //                 secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
        //                 document.getElementById('clipboardModalCopySecret').value = secret;
        //                 const mail_subject = encodeURIComponent(subject.value);
        //                 const mail_secret = encodeURIComponent(body.value + secret);
        //                 document.getElementById('modal-secret-mailer').href = "mailto:?subject=" + mail_subject + "&body=" + mail_secret;
        //             }
        //
        //             $('#copyLinkModal').modal();
        //         } else {
        //             showPasswordErrorPrompt()
        //         }
        //     }
        //
        //     passwordPrompt(callback)
        //
        // }
    } else {
        // hash = document.location.hash;
        // await launchDownloads(hash, name);
    }
}
/**
 * Main download procedure
 */
export async function mainDownload(db: IDBDatabase,
                                   row: FileData,
                                   passPhrase?: string): Promise<void>
{
    let hash;

    async function _download(key: CryptoKey) {
        const secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key)
        hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
        await launchDownloads(hash, row, passPhrase);
    }

    if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key

        const onerror = () => {}
        const oncomplete = async (event: any) => {
            let key = event.target.result;
            await _download(key);
        }

        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        } else {

            const callback = async (password: string) => {
                if (password) {
                    let key = await getSecretKey(password);
                    if (key) {
                        await _download(key)
                    } else {
                        showPasswordErrorPrompt()
                    }
                }
            };

            passwordPrompt(callback)
        }
    } else {
        hash = document.location.hash;
        await launchDownloads(hash, row, passPhrase);
    }
}



/**
 * get the download link
 */
export async function mainFileLink(db: IDBDatabase,
                                   row: FileData,
                                   forceSingleFile: boolean = false): Promise<void> {
    // let hash;

    if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key

        const onerror = () => {
            console.log('?')
        }

        let subject = document.getElementById('email_subject') as HTMLInputElement;
        let body = document.getElementById('email_body') as HTMLInputElement;
        let footer = document.getElementById('email_footer') as HTMLInputElement;

        const modalElement = document.getElementById('copyLinkModal')!;
        const modal = new bootstrap.Modal(modalElement)

        const oncomplete = async (event: any) => {


            modal.show()
            let key = event.target.result;
            let secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key)
            if (forceSingleFile && secret.includes('?prefix=')) {
                // inject the 'name' as a query_string arg into the secret
                const prefixIndex = secret.indexOf('?prefix=');
                const nameQS = "name=" + row.name + "&";
                secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
            }
            const clipboardSecret = document.getElementById('clipboardModalCopySecret') as HTMLInputElement;
            clipboardSecret.value = secret;
            const mail_subject = encodeURIComponent(subject.value);
            let mail_secret = encodeURIComponent(body.value.replace('\n', '\r\n'))  + '%0D%0A' + encodeURIComponent(secret);
            const e = document.getElementById('expiry-days-input') as HTMLSelectElement;
            const text = e. options[e. selectedIndex]. text;
            mail_secret += '%0D%0A%0D%0A' + encodeURIComponent(footer.value.replace('\n', '\r\n')) + encodeURIComponent(text)
            mail_secret += '%0D%0A%0D%0A' + encodeURIComponent('ARCANO.\nStay safe') + '%0D%0A' + encodeURIComponent('https://arcano.app');

            const mailToLink = document.getElementById('modal-secret-mailer') as HTMLAnchorElement;
            mailToLink.href = "mailto:?subject=" + mail_subject + "&body=" + mail_secret;

        }
        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        } else {


            const callback = async (modalPassword: string) => {
                let key = await getSecretKey(modalPassword);
                if (key) {
                    let secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key)
                    if (forceSingleFile && secret.includes('?prefix=')) {
                        // inject the 'name' as a query_string arg into the secret
                        const prefixIndex = secret.indexOf('?prefix=');
                        const nameQS = "name=" + row.name + "&";
                        secret = secret.slice(0, prefixIndex + 1) + nameQS + secret.slice(prefixIndex + 1);
                        const clipboardSecret = document.getElementById('clipboardModalCopySecret') as HTMLInputElement;
                        clipboardSecret.value = secret;
                        const mail_subject = encodeURIComponent(subject.value);
                        const mail_secret = encodeURIComponent(body.value + secret);
                        const mailLink = document.getElementById('modal-secret-mailer') as HTMLAnchorElement;
                        mailLink.href = "mailto:?subject=" + mail_subject + "&body=" + mail_secret;
                    }

                    modal.show()
                } else {
                    showPasswordErrorPrompt()
                }
            };

            passwordPrompt(callback)

        }
    } else {
        // hash = document.location.hash;
        // await launchDownloads(hash, name);
    }
}

/**
 * Get the filename
 */
export async function getMatchingFileName(hash: string, name: string, encryptedFilename: string): Promise<string> {

    if(!encryptedFilename) {
        return "";
    }

    const {algorithm, key} = await decryptSymmetricKey(hash);

    const sencryptedFilename = atob(encryptedFilename);

    let arraybuffer = convertStringToArrayBufferView(sencryptedFilename);

    const decryptedFilename = await window.crypto.subtle.decrypt(
        algorithm,
        key,
        arraybuffer
    );
    return new TextDecoder("utf-8").decode(decryptedFilename);
}

/**
 * Gets the encrypted message
 */
export async function decryptMessage(db: IDBDatabase, row: FileData): Promise<void> {

    async function _showMessage(key: CryptoKey) {
        const secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key)
        let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
        let message = await getMatchingFileName(hash, row.name, row.encrypted_message) as string;
        messagePrompt(message)
    }

    if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key
        const onerror = () => {}
        const oncomplete = async (ev: any) => {
            let key = ev.target.result;
            await _showMessage(key);
        }
        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        } else {
            const callback = async (password: string) => {
                if (password) {
                    let key = await getSecretKey(password);
                    if (key) {
                        await _showMessage(key);
                    } else {
                        showPasswordErrorPrompt()
                    }
                }
            };
            passwordPrompt(callback)
        }
    } else {

        // let hash = document.location.hash;  // todo when do we get here
        // let filename = await getMatchingFileName(hash, name, encryptedFilename);
        // console.log(filename)
        // event.target.innerHTML = filename;  // note: Attention
    }
}

/**
 *
 */
export async function encryptTransferName(db: IDBDatabase, row: DOMStringMap, transferName: string): Promise<string> {

    return new Promise((resolve, reject) => {
        const onerror = () => {
            reject(`${transferName} could not be changed`)
        }
        const oncomplete = async (ev: any) => {
            let privateKey = ev.target.result;
            const secret = await extractSecretUsingLocalSecretKey((row.encryptedkey as string) , privateKey)
            let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
            const split = hash.split('-');
            const counter = new Uint8Array(atob(split[0]).split(",").map(x => parseInt(x)));

            const keydata = JSON.parse(atob(split[1]));

            const algorithm = getSymmetricAlgorithm(counter);

            let transferKey = await window.crypto.subtle.importKey('jwk',
                keydata,
                algorithm,
                false,
                keydata.key_ops
            );

            const transferNameCleaned = transferName.replace(/[/\\?%*:|"<>]/gi, '');

            const errorMessage = 'Please do not use the following characters: / \ ? % * : | < >'

            if(transferNameCleaned.length === 0) {
                reject(errorMessage)
            }
            if(transferNameCleaned !== transferName) {
                reject(errorMessage)
            }

            let encryptedTransferName = await encryptMessage(new TextEncoder().encode(transferNameCleaned), transferKey, algorithm)

            let arr = Array.from(new Uint8Array(encryptedTransferName))
            const b64encryptedName = btoa(String.fromCharCode(...arr));
            // the rest is just for testing if we get the same thing again
            // const sencryptedFilename = atob(b64encryptedName);

            // let arraybuffer = convertStringToArrayBufferView(sencryptedFilename);

            // const decryptedFilename = await window.crypto.subtle.decrypt(
            //                 algorithm,
            //                 transferKey,
            //                 arraybuffer
            //          );
            // const decoded = new TextDecoder("utf-8").decode(decryptedFilename);
            // if(decoded !== transferName) {
            //     console.error('Problem')
            //     reject()
            // }
            //end test
            mfetch('/files/transfer/rename' , {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    prefix: row.prefix,
                    transfer_name: b64encryptedName
                })
            }).then((r) => {
                if (r.status === 200){
                    resolve(transferNameCleaned)
                } else {
                    reject(errorMessage)
                }
            })


        }
        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        }
    })
}


/**
 * Decrypt single filename in table
 */
export async function mainDecryptFilename(db: IDBDatabase, row: FileData): Promise<void> {

    /**
     * Inner textb replace function for single filename
     */
    async function _replaceButtonText(hash: string) {
        let encryptedFilename = row.encrypted_filepath
        if(!encryptedFilename || encryptedFilename === 'null') {
            encryptedFilename = row.encrypted_filename
        }


        let filename = await getMatchingFileName(hash, row.name, encryptedFilename) as string;
        const button = document.getElementById(`${row.prefix}-${row.name}`) as HTMLAnchorElement
        button!.innerText = filename
    }
    /**
     * Inner decrypt function for single filename
     */
    async function _decrypt(key: CryptoKey) {
        const secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key)
        let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
        await _replaceButtonText(hash);
    }

    if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key

        if (db) {
            const onerror = () => {}
            const oncomplete = async (ev: any) => {
                let key = ev.target.result;
                await _decrypt(key);
            }
            getItem(db, 'key', oncomplete, onerror)
        } else {
            const callback = async (modalPassword: string) => {
                let key = await getSecretKey(modalPassword);
                if (key) {
                    await _decrypt(key);
                } else {
                    showPasswordErrorPrompt()
                }
            };
            passwordPrompt(callback)
        }
    } else {
        let hash = document.location.hash;
        await _replaceButtonText(hash);
    }
}


/**
 * Decrypts all filenames
 */
export async function mainDecryptAllFilenames(db: IDBDatabase, event: Event, data: Array<FileData>): Promise<void> {
    if (data.length === 0) {
        return
    }

    /**
     * Inner decrypt loop for transfer names
     */

    async function _decryptTransfers(key: CryptoKey) {

        let lastPrefix = undefined
        for (let i = 0; i < data.length; i++) {
            const row = data[i]
            if(row.prefix !== lastPrefix ) {
                const transferName = document.getElementById(row.prefix)!;

                if (transferName.innerText === 'Transfer') {
                    continue
                }
                let secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key);
                let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
                let filename = await getMatchingFileName(hash, row.name, row.encrypted_transfername) as string;

                transferName.innerHTML = escapeHtml(filename);  // note: save innerHtml
                try {
                    data[i].filename = filename;
                } catch (e) {
                    console.log(e)
                }
            }
            lastPrefix = row.prefix
        }
    }
    /**
     * Inner decrypt loop for filenames
     */
    async function _decryptFilenames(key: CryptoKey) {
        for (let i = 0; i < data.length; i++) {
            const row = data[i]

            const decryptButton = document.getElementById(`${row.prefix}-${row.name}`) as HTMLButtonElement
            if (!decryptButton) {
                continue  // help against testcafe
            }

            let secret = await extractSecretUsingLocalSecretKey(row.encryptedkey, key);
            let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
            let encryptedFilename = row.encrypted_filepath
            if(!encryptedFilename || encryptedFilename === 'null') {
                encryptedFilename = row.encrypted_filename
            }
            let filename = await getMatchingFileName(hash, row.name, encryptedFilename) as string;

            decryptButton.innerHTML = escapeHtml(filename); // note: save innerHtml
            try {
                data[i].filename = filename;
            } catch (e) {
                console.log(e)
            }
        }
    }

    if (document.location.hash === "") { // this is the case of a private message, i.e. this used a public key
        const onerror = () => {
            console.log('error')
        }
        const oncomplete = (event: any) => {
            let key = event.target.result;
            try {
                _decryptFilenames(key);
            _decryptTransfers(key);
            } catch (e) {
                console.log(e)
            }

        }
        if (db) {
            getItem(db, 'key', oncomplete, onerror)
        } else {
            const callback = async (modalPassword: string) => {
                let key = await getSecretKey(modalPassword);
                if (key) {
                    await _decryptFilenames(key)
                    await _decryptTransfers(key);
                } else {
                    showPasswordErrorPrompt()
                }
            };
            passwordPrompt(callback)
        }
    } else {
        let hash = document.location.hash;
        for (let i = 0; i < data.length; i++) {
            const row = data[i]
            let encryptedFilename = row.encrypted_filepath
            if(!encryptedFilename || encryptedFilename === 'null') {
                encryptedFilename = row.encrypted_filename
            }
            let filename = await getMatchingFileName(hash, row.name, encryptedFilename);
            const decryptButton = document.getElementById(`${row.prefix}-${row.name}`) as HTMLButtonElement
            decryptButton.innerHTML = escapeHtml(filename);  // note: save innerHtml
            if(i === 0) {
                const transferName = document.getElementById(row.prefix)!
                if (transferName.innerText === 'Transfer') {
                    continue
                }
                let filename = await getMatchingFileName(hash, row.name, row.encrypted_transfername);
                transferName.innerHTML = escapeHtml(filename);  // note: save innerHtml

            }
        }
    }
}

/**
 * Show the message on external_download
 */
export async function showExternalDownloadMessage(encryptedMessage: string): Promise<void> {
    if (document.location.pathname.indexOf('external_download') < 0) {
        return;
    }

    let hash = window.location.hash;
    const {algorithm, key} = await decryptSymmetricKey(hash)

    window.location.pathname.replace('/', '');

    if (encryptedMessage === "") {
        return;
    }

    const sencryptedMessage = atob(encryptedMessage);

    let arraybuffer = convertStringToArrayBufferView(sencryptedMessage);

    const decryptedMessage = await window.crypto.subtle.decrypt(
        algorithm,
        key,
        arraybuffer
    );
    const realMessage = new TextDecoder("utf-8").decode(decryptedMessage);

    const block = document.getElementById('external-download-message')!;
    block.style.display = 'block';
    const text = document.getElementById('external-download-message-content')!;
    text.innerText = realMessage;

}


export const handleTransferRenaming = (db: IDBDatabase) => {
    if(document.location.href.indexOf('/external_download') >= 0) {
        return
    }
    document.addEventListener('click', (e) => {
        const element = e.target as HTMLElement;
        const parent = element.parentElement as HTMLElement;
        let messageButton: any = null;
        if (parent) {
            messageButton = parent.querySelector('.message-button') as HTMLElement
        }
        if(element.classList.contains('transfer-item-header-title-inner')){

            let value = element.innerText.trim()

            let input = document.createElement('input')
            input.classList.add("transfer-header-input")
            input.value = value
            input.type = 'text'

            parent.appendChild(input);
            element.style.display = 'none'
            input.focus()
            input.select()
            if(messageButton) {
                messageButton.style.display = 'none'
            }

            input.addEventListener('keypress', (e2) => {
                if (e2.key === 'Enter' || e2.key === 'Escape') {
                    e2.preventDefault()
                    input.blur()
                }
            })

            // function showError(element: HTMLElement, error: string) {
            //     const tooltip = createElemWithClasses('div', ['popper-error-message'])
            //     tooltip.innerText = error;
            //     document.body.appendChild(tooltip)
            //     let message = createPopper(element, tooltip, {
            //       placement: 'bottom-start',
            //     });
            //     setInterval(() => {
            //         message.destroy();
            //         tooltip.remove()}, 5000)
            // }
            input.addEventListener('blur', (e2) => {
                const target = e2.target as HTMLInputElement;
                if(input.value.trim() === "") {
                    element.style.display = 'block'
                    target.remove()
                    return
                }
                if(messageButton) {
                    messageButton.style.display = 'block'
                }

                const row = element.closest('li')!.dataset
                let error: any = undefined;
                encryptTransferName(db, row, input.value.trim())
                    .then((result) => {
                        element.innerText = result;
                    })
                    .catch((err) => {
                        error = err;
                    })
                    .finally(() => {
                        element.style.display = 'block'
                        target.remove()
                        if(error) {
                            showTooltip(element, error, 'bottom-start', 5000)
                        }
                    })
            })
        }
    })
}

function checkOrgInvitation() {
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if(target.id === 'goto-invite-button') {
            e.preventDefault();
            if (window.location.pathname.includes('/de/')) {
                window.location.href = '/de/organization'
            } else if (window.location.pathname.includes('/fr/')) {
                window.location.href = '/fr/organization'
            } else {
                window.location.href = '/organization'
            }
        }
    })

    mfetch('/has_org_invite').then(response => {
        if(response.status === 200) {
            response.text().then(data => {
                const result = JSON.parse(data)
                if('organization' in result) {
                    showFlash(`<a id="goto-invite-button">You have been invited to the organization ${result['organization']}, click here to view your invitation</a>`, 'info', 'new-org-invite')
                }
            })
        }
    }).catch(() => {})
}

document.addEventListener("DOMContentLoaded", function () {

    if(document.location.href.indexOf('/external_download') < 0) {
        document.location.hash = ''
    }

    const hideHowto = document.getElementById('hide-receive-howto-button')
    if(hideHowto) {
        hideHowto.addEventListener('click', (e) => {
            e.preventDefault()
            fetch('/receive_howto').then(() => {
                document.getElementById('howto-receive-show')!.classList.remove('d-none')
                document.getElementById('howto-receive')!.classList.add('d-none')
            })
        })
    }

    const showHowto = document.getElementById('show-receive-howto-button')
    if(showHowto) {
        showHowto.addEventListener('click', (e) => {
            e.preventDefault()
            fetch('/receive_howto?reset=1').then(() => {
                document.getElementById('howto-receive-show')!.classList.add('d-none')
                document.getElementById('howto-receive')!.classList.remove('d-none')

            })
        })
    }

    updateFileCounters();
    checkNewFiles();

    checkOrgInvitation();

    // if(document.location.href.includes('external_download')) {
    //     showExternalDownloadMessage().then(() => {})
    // }

});
